export const colorWhite = '#fff'
export const colorGrayLighter = '#fafafa'
export const colorGrayLight = '#ddd'
export const colorGrayWarm = '#9b9b9b'
export const colorBlack = '#4a4a4a'
export const colorBlue = '#06aeed'
export const colorGreen = '#547107'
export const colorRed = '#e3343b'
export const colorWine = '#5A0D46'

export const colorText = colorBlack
export const colorPrimary = colorBlue
export const colorBorder = colorGrayLight
